import { useEffect } from "react";
import { useNavigate } from "react-router";
import { AuthRepository } from "@/api/auth/repository";
import { AuthService } from "@/api/auth/service";
import { notificationsCenter } from "@/components/Notifications/model";
import { LS } from "@/constants/index";
import { ROUTES } from "@/router";
import { useAppStore } from "@/store/app/slice";
import { AuthState } from "@/types/common";
import { UserLoadingStatus } from "@/types/users";

const SignOut = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const authRepository = new AuthRepository(new AuthService());
    void authRepository.logout();

    useAppStore.getState().setAuthenticated(AuthState.Unauthenticated);
    useAppStore.getState().setUser(null);
    useAppStore.getState().setUserLoaded(UserLoadingStatus.NotStarted);
    useAppStore.getState().setAccessToken("");

    localStorage.removeItem(LS.RefreshToken);
    notificationsCenter.reset();

    navigate(`/${ROUTES.AUTH}/${ROUTES.SIGN_IN}`);
  }, [navigate]);

  return null;
};

export default SignOut;
